import React, { PropsWithChildren, ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import { Box, Grid, Typography } from '@mui/material';
import { PromotionUpliftStats } from 'promotions/components';

import { selectProviderPromotionsPermissions } from 'rdx/promotions/selectors';

import { useSelectedProvider } from 'root/hooks/useSelectedProvider';
import { routes } from 'root/promotions/routes';

import { PromotionAccessType } from '../../../../../common/all/api/gen/CampaignDeliveryProvider';
import { StatNotAvailableReason } from '../PromotionUpliftStats/PromotionUpliftStats';

export interface PromotionCardFCProps {
  strings: {
    title: ReactNode;
  };
  subtitle?: ReactNode;
  onClose: () => void;
  statsBoxProps?: {
    upliftStats?: {
      weeklySpend?: {
        currency: string;
        value: number;
      };
      weeklyImpact?: {
        currency: string;
        gmvValue: number;
      };
      newUsers?: number;
    };
    showUpliftStatsSkeletons?: boolean;
    isStatAvailable?: boolean;
    statNotAvailableReason?: StatNotAvailableReason;
  };
}

export const PromotionCardFC = ({
  strings,
  subtitle,
  children,
  statsBoxProps,
}: PropsWithChildren<PromotionCardFCProps>) => {
  const location = useLocation();
  const providerPromotionsPermissions = useSelector(selectProviderPromotionsPermissions);
  const promotionAccessType = providerPromotionsPermissions?.promotion_access_type;
  const shouldShowUpliftStats =
    !useSelectedProvider().permissions.canSeeSmartPromotions &&
    location.pathname === routes.addPromotion &&
    promotionAccessType !== PromotionAccessType.SELECTED_ITEMS;

  return (
    <Grid container maxWidth="xl" spacing="24px">
      <Grid item xs={12} xl={9}>
        <Box paddingBottom={3}>
          <Typography variant="h3">{strings.title}</Typography>
        </Box>
        {subtitle && <Box paddingBottom={2}>{subtitle}</Box>}
        {children}
      </Grid>

      {shouldShowUpliftStats && (
        <Grid item xs={3}>
          <PromotionUpliftStats
            upliftStats={statsBoxProps.upliftStats}
            showUpliftStatsSkeletons={statsBoxProps.showUpliftStatsSkeletons}
            isStatAvailable={statsBoxProps.isStatAvailable}
            statNotAvailableReason={statsBoxProps.statNotAvailableReason}
          />
        </Grid>
      )}
    </Grid>
  );
};
